<template>
  <div>
    <Toolbar />
    <v-layout class="d-flex flex-column mt-10 mx-5">
      <IconoHeader icono="file-search-outline" />
      <h4 class="texto-titulo font-weight-bold text-center mt-5">
        ¡Verifica que todo sea correcto!
      </h4>
      <v-card class="mt-5 px-4 py-1 rounded-lg" elevation="2">
        <v-list-item>
          <v-list-item-content>
            <p>Resumen del crédito</p>
            <div v-if="tipoPersona == 1">
              <v-subheader
                v-text="credito.monto.title"
                class="px-0 my-0 mt-3"
                style="height: 100%"
              ></v-subheader>
              <v-list-item-title>
                {{ montoMoneda(credito.monto.val) }}</v-list-item-title
              >
            </div>
            <div v-else>
              <div
                class="
                  d-flex
                  flex-row
                  justify-space-between
                  font-weight-light
                  grey--text
                  text--darken-2
                  body-2
                "
              >
                <div class="text-center font-weight-regular">
                  <span class="grey--text text--darken-2"
                    >MONTO SOLICITADO</span
                  >
                  <br />
                  <span class="black--text">
                    {{ montoMoneda(credito.monto.val) }}
                  </span>
                </div>
                <div class="text-center font-weight-regular">
                  <span class="grey--text text--darken-2"
                    >APORTACION SOCIAL</span
                  >
                  <br />
                  <span class="black--text"> -$500.00 </span>
                </div>
                <div class="text-center font-weight-regular">
                  <span class="grey--text text--darken-2"
                    >MONTO A DEPOSITAR</span
                  >
                  <br />
                  <span class="black--text">
                    = {{ montoMoneda(credito.monto.val - 500) }}
                  </span>
                </div>
              </div>
            </div>
            <v-divider :inset="true" class="ml-1"></v-divider>
            <v-subheader
              v-text="credito.frecuenciaSeleccionada.title"
              class="px-0 my-0 mt-3"
              style="height: 100%"
            ></v-subheader>
            <v-list-item-title>
              {{ credito.frecuenciaSeleccionada.val }}
            </v-list-item-title>
            <v-divider :inset="true" class="ml-1"></v-divider>
            <v-subheader
              v-text="credito.plazo.title"
              class="px-0 my-0 mt-3"
              style="height: 100%"
              >{{ credito.plazo.title }}</v-subheader
            >
            <v-list-item-title>{{
              credito.plazo.val + ' ' + credito.plazo.mask
            }}</v-list-item-title>
            <v-divider :inset="true" class="ml-1"></v-divider>
            <v-subheader
              v-text="credito.tasa.title"
              class="px-0 my-0 mt-3"
              style="height: 100%"
            ></v-subheader>
            <v-list-item-title>
              {{ credito.tasa.val }}% mensual</v-list-item-title
            >
            <v-divider :inset="true" class="ml-1"></v-divider>
            <v-subheader
              v-text="credito.montoPago.title"
              class="px-0 my-0 mt-3"
              style="height: 100%"
            ></v-subheader>
            <v-list-item-title class="font-weight-bold">
              Tu pago {{ credito.frecuenciaSeleccionada.val.toLowerCase() }} es
              de {{ montoMoneda(credito.montoPago.val) }}
            </v-list-item-title>
            <v-divider :inset="true" class="ml-1"></v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <div class="d-flex flex-row justify-center mt-5 mb-5">
        <v-btn
          class="align-self-center mt-0 mx-2"
          color="primary"
          text
          elevation="2"
          @click="iraEditar"
          >EDITAR<v-icon right light>mdi-pencil</v-icon></v-btn
        >
        <v-btn
          class="align-self-center mt-0 mr-2 mx-2"
          color="primary"
          elevation="2"
          @click="confirmarCredito"
          :loading="cargando"
          :disabled="cargando"
          >CONFIRMAR<v-icon right light>mdi-check</v-icon></v-btn
        >
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import OtpService from '@/servicios/otp'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { FormatoMonedaMixin } from '@/mixins/formateos/FormatoMoneda.mixin'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: { IconoHeader, Toolbar },
  name: 'ConfirmacionOferta',
  mixins: [FormatoMonedaMixin, InsertaLogMixin],
  data: () => ({
    credito: '',
    cargando: false,
    tipoPersona: 1,
  }),
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.credito = this.$store.getters['credito/obtenerCredito']
    this.$store.commit('credito/setEditable', true)
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
  },
  methods: {
    updateMonto() {
      this.$store.credito = this.credito
      this.$store.dispatch('credito/actualizarCredito', this.credito)
    },
    iraEditar() {
      this.$store.dispatch('credito/actualizarEditable', false)
      if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
        this.$router.push('/actualizaMonto')
      } else {
        this.$router.push('parametrizacion-editar')
      }
    },
    async confirmarCredito() {
      await this.enviarOtp()
      this.$store.dispatch('credito/actualizarConfirmacion', true)
      this.$store.dispatch('credito/actualizarEditable', false)
      this.$router.push('aceptacion-contratos')
    },
    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      let result
      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          result.data.Mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
}
</script>

<style scoped>
.v-divider--inset:not(.v-divider--vertical) {
  max-width: 100%;
}
</style>
